import * as types from './types';
import createReducer from '../../createReducer';
import { getServicesByType } from 'utils';
import Immutable from 'seamless-immutable';
import { FETCH_STATE } from 'constants/common';

export const initialState = Immutable({
  user: null,
  errors: {},
  bastions: [],
  loading: false,
  needsOTP: false,
  verifyOTP: false,
  fetchingUser: true,
  isAuthenticated: false,
  currentOrganization: {},
  organizations: {
    current: {},
    owned: [],
    services: [],
  },
  fetchedEmailConfirm: false,
  fetchedUpdateAccount: false,
  fetchingUpdateAccount: false,
  fetchingChangePassword: false,
  fetchChangePasswordSuccess: false,
  fetchedChangePasswordSuccess: false,
  unauthorized: false,
  clients: null,
  fetchingClients: FETCH_STATE.UNSENT,
  startingTwoFactor: FETCH_STATE.UNSENT,
  twoFactorId: null,
  fetchingTwoFactorLogin: FETCH_STATE.UNSENT,
  trustToken: null,
  fetchingTwoFactorConfiguration: FETCH_STATE.UNSENT,
  savingTwoFactorConfiguration: FETCH_STATE.UNSENT,
  twoFactorConfiguration: null,
  currentBastion: null,
  currentClient: null,
  currentEmail: null,
  onboarding: {
    loading: false,
    exitOnboarding: false,
    exitStep: false,
    lastStep: false,
    position: 0,
    errors: {},
    steps: {},
    enableForm: null,
  },
});

const userReducer = createReducer(initialState)({
  [types.FETCH_LOGIN_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      isAuthenticated: false,
    };
  },
  [types.FETCH_LOGIN_SUCCESS]: (state, { payload }) => {
    const currentOrganization = payload?.to_orgs?.find((val) => val.is_default) || {};
    return {
      ...state,
      loading: false,
      user: payload.user,
      organizations: {
        ...state.organization,
        // organizations list
        list: getServicesByType(payload?.to_orgs || []),
        current: currentOrganization?.organization,
      },
      isAuthenticated: true,
    };
  },
  [types.FETCH_LOGIN_FAILED]: (state) => {
    return {
      ...state,
      user: null,
      loading: false,
      fetchingUser: false,
      isAuthenticated: false,
    };
  },
  [types.FETCH_OAUTH_LOGIN_SUCCESS]: (state) => {
    // const currentOrganization = payload?.to_orgs?.find((val) => val.is_default) || {};
    return {
      ...state,
      loading: false,
      // user: payload.user,
      // organizations: {
      //   ...state.organization,
      //   // organizations list
      //   list: getServicesByType(payload?.to_orgs || []),
      //   current: currentOrganization?.organization,
      // },
      isAuthenticated: true,
    };
  },
  [types.FETCH_LOGIN_MFA_SUCCESS]: (state) => {
    return {
      ...state,
      loading: false,
      needsOTP: true,
    };
  },
  [types.SET_LOGGED_IN]: (state) => {
    return {
      ...state,
      fetchingUser: false,
      isAuthenticated: true,
      loading: false,
    };
  },

  [types.FETCH_UNAUTHORIZED]: (state) => {
    return {
      ...state,
      unauthorized: true,
    };
  },
  [types.FETCH_UNAUTHORIZED_PAGE]: (state) => {
    return {
      ...state,
      unauthorized: false,
    };
  },

  [types.FETCH_USER_REQUEST]: (state) => {
    return {
      ...state,
      fetchingUser: true,
      user: {
        ...state.user,
        organization: null,
      },
    };
  },
  [types.FETCH_USER_SUCCESS]: (state, { payload }) => {
    const organization = payload.organization || {};
    const { to_orgs, ...user } = payload || {};
    const { owned_organizations, ...currentOrganization } = organization || {};
    return {
      ...state,
      user,
      currentOrganization: organization,
      organizations: {
        // organizations list
        list: getServicesByType(to_orgs),
        // get all owned organizations
        services: owned_organizations || [],
        current: currentOrganization || {},
      },
    };
  },
  [types.FETCH_USER_FAILED]: (state) => {
    return {
      ...state,
      fetchingUser: false,
    };
  },

  [types.FETCH_REFRESH_TOKEN_REQUEST]: (state) => {
    return {
      ...state,
    };
  },
  [types.FETCH_REFRESH_TOKEN_SUCCESS]: (state) => {
    return {
      ...state,
      isAuthenticated: true,
    };
  },
  [types.FETCH_REFRESH_TOKEN_FAILED]: (state) => {
    return {
      ...state,
      user: null,
      loading: false,
      isAuthenticated: false,
    };
  },

  [types.FETCH_FORGOT_PASSWORD_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
    };
  },
  [types.FETCH_FORGOT_PASSWORD_SUCCESS]: (state) => {
    return {
      ...state,
      loading: false,
    };
  },
  [types.FETCH_FORGOT_PASSWORD_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
    };
  },

  [types.FETCH_CHANGE_PASSWORD_REQUEST]: (state) => {
    return {
      ...state,
      fetchingChangePassword: true,
      fetchedChangePasswordSuccess: false,
    };
  },
  [types.FETCH_CHANGE_PASSWORD_SUCCESS]: (state) => {
    return {
      ...state,
      fetchingChangePassword: false,
      fetchedChangePasswordSuccess: true,
    };
  },
  [types.FETCH_CHANGE_PASSWORD_FAILED]: (state) => {
    return {
      ...state,
      fetchingChangePassword: false,
      fetchedChangePasswordSuccess: false,
    };
  },

  [types.FETCH_MFA_REQUEST]: (state) => {
    return {
      ...state,
      needsOTP: false,
      verifyOTP: false,
    };
  },
  [types.FETCH_MFA_SUCCESS]: (state) => {
    return {
      ...state,
      verifyOTP: true,
    };
  },
  [types.FETCH_MFA_FAILED]: (state) => {
    return {
      ...state,
      verifyOTP: false,
    };
  },

  [types.FETCH_SET_PASSWORD_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      fetchChangePasswordSuccess: false,
    };
  },
  [types.FETCH_SET_PASSWORD_SUCCESS]: (state) => {
    return {
      ...state,
      loading: false,
      fetchChangePasswordSuccess: true,
    };
  },
  [types.FETCH_SET_PASSWORD_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
      fetchChangePasswordSuccess: false,
    };
  },
  [types.FETCH_RESET_PASSWORD]: (state) => {
    return {
      ...state,
      loading: false,
      fetchChangePasswordSuccess: false,
    };
  },

  [types.RESEND_OTP_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      errorResendOtp: null,
    };
  },
  [types.RESEND_OTP_SUCCESS]: (state) => {
    return {
      ...state,
      loading: false,
      errorResendOtp: null,
    };
  },
  [types.RESEND_OTP_FAILED]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      errorResendOtp: payload,
    };
  },
  [types.RESET_OTP_SUCCESS]: (state) => {
    return {
      ...state,
      needsOTP: false,
      errorResendOtp: null,
    };
  },

  [types.FETCH_EMAIL_CONFIRM_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      fetchedEmailConfirm: false,
    };
  },
  [types.FETCH_EMAIL_CONFIRM_SUCCESS]: (state) => {
    return {
      ...state,
      loading: false,
      fetchedEmailConfirm: true,
    };
  },
  [types.FETCH_EMAIL_CONFIRM_FAILED]: (state, { error }) => {
    return {
      ...state,
      errors: error,
      loading: false,
      fetchedEmailConfirm: false,
    };
  },

  [types.FETCH_BASTIONS_REQUEST]: (state) => {
    return {
      ...state,
      bastions: [],
      loading: true,
      errors: {
        ...state.errors,
        bastions: null,
      },
    };
  },
  [types.FETCH_BASTIONS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      bastions: payload || [],
      loading: false,
      errors: {
        ...state.errors,
        bastions: null,
      },
    };
  },
  [types.FETCH_BASTIONS_FAILED]: (state, { error, errKey }) => {
    return {
      ...state,
      loading: false,
      errors: {
        ...state.errors,
        errKey,
        bastions: error,
      },
    };
  },
  [types.FETCH_RESET_BASTIONS]: (state) => {
    return {
      ...state,
      loading: false,
      bastions: [],
      errors: {},
    };
  },
  [types.SET_CURRENT_BASTION]: (state, { payload }) => {
    return {
      ...state,
      currentBastion: payload.bastion,
      currentClient: payload.client,
      currentEmail: payload.email,
    };
  },

  // UPDATE ACCOUNT
  [types.FETCH_UPDATE_ACCOUNT_REQUEST]: (state, { payload }) => {
    return {
      ...state,
      fetchingUpdateAccount: true,
      fetchedUpdateAccount: payload.type === 'code' ? true : false,
    };
  },
  [types.FETCH_UPDATE_ACCOUNT_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      user: payload || state.user,
      fetchingUpdateAccount: false,
      fetchedUpdateAccount: true,
    };
  },
  [types.FETCH_UPDATE_ACCOUNT_FAILED]: (state, { errors }) => {
    return {
      ...state,
      fetchingUpdateAccount: false,
      errors,
    };
  },

  // UPDATE ACCOUNT
  [types.FETCH_ACCESS_TOKEN_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
    };
  },
  [types.FETCH_ACCESS_TOKEN_SUCCESS]: (state) => {
    return {
      ...state,
      loading: false,
    };
  },
  [types.FETCH_ACCESS_TOKEN_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
    };
  },

  [types.USER_LOGGED_OUT]: (state) => {
    return {
      ...state,
      user: null,
      fetchingUser: false,
      isAuthenticated: false,
      bastions: [],
    };
  },

  [types.RESET_VERIFICATION_CODE]: (state) => {
    return {
      ...state,
      fetchedUpdateAccount: false,
    };
  },

  // GET BASTION APP ID
  [types.FETCH_CLIENTS_REQUEST]: (state) => {
    return {
      ...state,
      fetchingClients: FETCH_STATE.LOADING,
    };
  },
  [types.FETCH_CLIENTS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      clients: payload,
      fetchingClients: FETCH_STATE.DONE,
    };
  },
  [types.FETCH_CLIENTS_FAILED]: (state) => {
    return {
      ...state,
      fetchingClients: FETCH_STATE.ERROR,
      fetchingUser: false,
    };
  },

  // START TWO FACTOR
  [types.FETCH_START_TWO_FACTOR_REQUEST]: (state) => {
    return {
      ...state,
      trustToken: null,
      fetchingTwoFactorLogin: FETCH_STATE.UNSENT,
      startingTwoFactor: FETCH_STATE.LOADING,
      twoFactorId: null,
    };
  },
  [types.FETCH_START_TWO_FACTOR_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      startingTwoFactor: FETCH_STATE.DONE,
      twoFactorId: payload?.twoFactorId,
    };
  },
  [types.FETCH_START_TWO_FACTOR_FAILED]: (state) => {
    return {
      ...state,
      startingTwoFactor: FETCH_STATE.ERROR,
      twoFactorId: null,
    };
  },

  // TWO FACTOR LOGIN
  [types.FETCH_TWO_FACTOR_LOGIN_REQUEST]: (state) => {
    return {
      ...state,
      fetchingTwoFactorLogin: FETCH_STATE.LOADING,
      trustToken: null,
    };
  },
  [types.FETCH_TWO_FACTOR_LOGIN_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingTwoFactorLogin: FETCH_STATE.DONE,
      trustToken: payload.trustToken,
    };
  },
  [types.FETCH_TWO_FACTOR_LOGIN_FAILED]: (state) => {
    return {
      ...state,
      trustToken: null,
      fetchingTwoFactorLogin: FETCH_STATE.ERROR,
    };
  },
  // TWO FACTOR CONFIGURATION
  [types.FETCH_TWO_FACTOR_CONFIG_REQUEST]: (state) => {
    return {
      ...state,
      fetchingTwoFactorConfiguration: FETCH_STATE.LOADING,
      twoFactorConfiguration: null,
    };
  },
  [types.FETCH_TWO_FACTOR_CONFIG_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingTwoFactorConfiguration: FETCH_STATE.DONE,
      twoFactorConfiguration: payload,
    };
  },
  [types.FETCH_TWO_FACTOR_CONFIG_FAILED]: (state) => {
    return {
      ...state,
      twoFactorConfiguration: null,
      fetchingTwoFactorConfiguration: FETCH_STATE.ERROR,
    };
  },
  // SET TWO FACTOR CONFIGURATION
  [types.SET_TWO_FACTOR_CONFIG_REQUEST]: (state) => {
    return {
      ...state,
      savingTwoFactorConfiguration: FETCH_STATE.LOADING,
      twoFactorConfiguration: null,
    };
  },
  [types.SET_TWO_FACTOR_CONFIG_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      savingTwoFactorConfiguration: FETCH_STATE.DONE,
      twoFactorConfiguration: payload,
    };
  },
  [types.SET_TWO_FACTOR_CONFIG_FAILED]: (state) => {
    return {
      ...state,
      twoFactorConfiguration: null,
      savingTwoFactorConfiguration: FETCH_STATE.ERROR,
    };
  },
  // ONBOARDING CHANGE POSITION
  [types.CHANGE_POSITION]: (state, { payload }) => {
    return {
      ...state,
      onboarding: {
        ...state.onboarding,
        exitOnboarding: false,
        position: payload.position,
      },
    };
  },
  // ONBOARDING ENABLE IDP FORM
  [types.ENABLE_IDP_FORM]: (state, { payload }) => {
    return {
      ...state,
      onboarding: {
        ...state.onboarding,
        enableForm: payload.enable,
      },
    };
  },
  // UPSERT IDENTITY PROVIDER
  [types.FETCH_UPSERT_IDENTITY_PROVIDER_REQUEST]: (state) => {
    return {
      ...state,
      onboarding: {
        ...state.onboarding,
        loading: true,
        errors: {},
      },
    };
  },
  [types.FETCH_UPSERT_IDENTITY_PROVIDER_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      onboarding: {
        ...state.onboarding,
        loading: false,
        steps: {
          ...state.onboarding.steps,
          [payload.step]: payload.data,
        },
      },
    };
  },
  [types.FETCH_UPSERT_IDENTITY_PROVIDER_FAILED]: (state, { payload }) => {
    return {
      ...state,
      onboarding: {
        ...state.onboarding,
        loading: false,
        errors: payload?.errors || {},
      },
    };
  },
  // IMPORT CERTIFICATE
  [types.FETCH_IMPORT_CERTIFICATE_REQUEST]: (state) => {
    return {
      ...state,
      onboarding: {
        ...state.onboarding,
        loading: true,
        errors: {},
      },
    };
  },
  [types.FETCH_IMPORT_CERTIFICATE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      onboarding: {
        ...state.onboarding,
        loading: false,
        exitOnboarding: true,
        steps: {
          ...state.onboarding.steps,
          [payload.step]: payload.data,
        },
      },
    };
  },
  [types.FETCH_IMPORT_CERTIFICATE_FAILED]: (state, { payload }) => {
    return {
      ...state,
      onboarding: {
        ...state.onboarding,
        loading: false,
        errors: payload?.errors || {},
      },
    };
  },

  // GET IDENTITY PROVIDER
  [types.FETCH_IDENTITY_PROVIDER_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      onboarding: {
        ...state.onboarding,
        exitOnboarding: false,
        exitStep: false,
        lastStep: false,
        position: 0,
        errors: {},
        steps: {},
        enableForm: null,
      },
    };
  },
  [types.FETCH_IDENTITY_PROVIDER_SUCCESS]: (state, { payload, page }) => {
    return {
      ...state,
      onboarding: {
        ...state.onboarding,
        steps: {
          ...state.onboarding.steps,
          [page]: payload || {},
        },
        enableForm: payload ? false : true,
      },
      loading: false,
    };
  },
  [types.FETCH_IDENTITY_PROVIDER_FAILED]: (state, { error }) => {
    return {
      ...state,
      loading: false,
      onboarding: {
        ...state.onboarding,
        errors: error || {},
        enableForm: true,
      },
    };
  },
});

export default userReducer;
